import VinculadorSimples from "../../../../../Components/Table/Vinculador";
import {
    ListarGruposVinculadosPorUsuarioController,
    ListarGruposNaoVinculadosPorUsuarioController,
    VincularGruposUsuarioController,
    DesVincularGruposUsuarioController,
} from "../../../../../Controllers/Geral/Grupos/GruposUsuarioController";

interface GruposProps {
    idUsuario: number;
    updateUser: (idUsuario: number) => void;
}

export default function Grupos(props: GruposProps) {
    const { updateUser } = props;

    return (
        <VinculadorSimples
            id={props.idUsuario}
            title="Função por grupo"
            listarVinculados={ListarGruposVinculadosPorUsuarioController}
            listarNaoVinculados={ListarGruposNaoVinculadosPorUsuarioController}
            multiplo={{
                desvincular: (gs) =>
                    DesVincularGruposUsuarioController(
                        gs.map((g) => g.ID_GRUPO_USUARIO || 0)
                    ).then(() => updateUser(props.idUsuario)),
                vincular: (idUsuario, grupos) =>
                    VincularGruposUsuarioController(
                        grupos.map((grupo) => ({
                            ID_USUARIO: idUsuario,
                            ID_GRUPO: grupo.ID_GRUPO,
                        }))
                    ).then(() => updateUser(props.idUsuario)),
            }}
            tabelaVinculados={{
                text: "Grupos Vinculados",
                dataField: "DS_GRUPO",
                key: "ID_GRUPO_USUARIO",
            }}
            tabelaDesvinculados={{
                text: "Grupos Desvinculados",
                dataField: "DS_GRUPO",
                key: "ID_GRUPO",
            }}
        />
    );
}
